import { Table, Tag } from "antd";
import { ConditionStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import type { ColumnsType } from "antd/es/table";

interface ConditionRow {
    key: string;
    conditionKey: string;
    operator: string;
    value: string;
    value2: string;
    state: boolean | null;
}

export interface StepDetailConditionProps {
    extractedData: ConditionStepSummary;
}

export const StepDetailCondition: FC<StepDetailConditionProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.condition");
    const { t: tGL } = usePaldockTranslation("drawers.general-labels");

    const rows: ConditionRow[] = extractedData.rules.map((rule, index) => ({
        key: String(index),
        conditionKey: rule.key,
        operator: rule.operator,
        value: rule.value,
        value2: rule.value2,
        state: rule.state,
    }));

    const columns: ColumnsType<ConditionRow> = [
        { title: t("key"), dataIndex: "conditionKey", key: "conditionKey" },
        { title: t("operator"), dataIndex: "operator", key: "operator" },
        { title: t("value"), dataIndex: "value", key: "value" },
        { title: t("value2"), dataIndex: "value2", key: "value2" },
        {
            title: t("state"),
            dataIndex: "state",
            key: "state",
            render: (state: boolean | null) => {
                if (state === null) return "-";
                return state ? <Tag color="green">{tGL("ok")}</Tag> : <Tag color="red">{tGL("fail")}</Tag>;
            },
        },
    ];

    return (
        <DrawerCollapsible title={t("data")}>
            <Table columns={columns} dataSource={rows} pagination={false} size="small" bordered={false} />
        </DrawerCollapsible>
    );
};
